import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowQuestionnaireFieldItem } from 'src/interfaces/reservation_flow';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';
import { RSSelect } from 'src/reservation-page/forms/RSSelect';

export interface QuestionnaireInputSelectProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowQuestionnaireFieldItem;
  isError?: boolean;
}

export const QuestionnaireInputSelect = forwardRef<
  HTMLSelectElement,
  QuestionnaireInputSelectProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item, isError } = props;

  const intl = useIntl();

  const onInputChange = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div>
      <div className="mb-1.5">
        <div className="rs-font text-16 text-gray-1000 pc:text-15 whitespace-pre-wrap font-normal">
          {item.label}
        </div>
      </div>
      <div>
        <RSSelect
          {...dataAttributes}
          ref={ref}
          labelText={intl.formatMessage({
            defaultMessage: '回答内容',
            id: 'kdYexJ',
            description:
              'src/templates/merchants/resources/book/event_type/MainTemplate/components/QuestionnaireInputSelect/index.tsx',
          })}
          hasSelectedValue={
            value && item.options ? item.options.includes(value) : false
          }
          isBlock
          isError={isError}
          required={item.is_required}
          value={typeof value !== 'undefined' ? value : ''}
          onChange={onInputChange}
          onBlur={onBlur}
        >
          <option
            value=""
            style={{ display: item.is_required ? 'none' : undefined }}
          />
          {item.options &&
            item.options.map((option) => {
              return (
                <option
                  key={`questionnaire_${item.id}_${option}`}
                  value={option}
                >
                  {option}
                </option>
              );
            })}
        </RSSelect>
      </div>
    </div>
  );
});

QuestionnaireInputSelect.displayName = 'QuestionnaireInputSelect';
